var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 0.12911C23.6435 0.118137 23.5362 0.118137 23.4297 0.12911H1.55469C1.41449 0.13127 1.27522 0.152292 1.14062 0.19161L12.4297 11.4338L23.75 0.12911Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9062 1.21503L13.5312 12.5432C13.2385 12.8342 12.8425 12.9975 12.4297 12.9975C12.0169 12.9975 11.6209 12.8342 11.3281 12.5432L0.0546875 1.30096C0.0200308 1.42834 0.00165522 1.55959 0 1.69159V17.3166C0 17.731 0.16462 18.1284 0.457646 18.4214C0.750671 18.7145 1.1481 18.8791 1.5625 18.8791H23.4375C23.8519 18.8791 24.2493 18.7145 24.5424 18.4214C24.8354 18.1284 25 17.731 25 17.3166V1.69159C24.9938 1.52882 24.9622 1.36802 24.9062 1.21503ZM2.63281 17.3166H1.54688V16.1994L7.22656 10.5666L8.32812 11.6682L2.63281 17.3166ZM23.4219 17.3166H22.3281L16.6328 11.6682L17.7344 10.5666L23.4141 16.1994L23.4219 17.3166Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/iconEmail.b4a1af7935fb7ebdb4d0a8b7147bc2c8.svg";
export { ForwardRef as ReactComponent };